import { Grid, Typography, Box, Button, TextField } from "@material-ui/core";
import { useMountAPI } from "../hooks/APICall";
import {
  WHITE,
  GREEN_PRIMRY,
  BLUE_COLOR,
  ERROR_COLOR,
  ORANGE_COLOR,
  BLUE_PRIMARY,
  DARK_SIDEBAR,
} from "../utils/const";
import Call from "../service/API";
import useCustomState from "../hooks/State";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { convertNumbers } from "../utils/ConvertNumbers";
import Loading from "../components/loading";
import SuccessModal from "../components/generalModals/SuccessModal";
import moment from "jalali-moment";
import { Split } from "../utils/Split";
import InfoIcon from "@material-ui/icons/Info";
import { Link, useHistory } from "react-router-dom";
import NotFound from "../components/notFound";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { UpdateBillsTable } from "../store/actions";

const Bills = (props) => {
  const updateBillsTable = useSelector(
    (state) => state.updateCommands.updateBillsTable
  );

  const dispatch = useDispatch();

  const serial = props.match.params.counterSerial;

  const history = useHistory();

  const successModalOpen = useCustomState(false);
  const successTitle = useCustomState("");
  const successMessage = useCustomState("ثبت اطلاعات با موفقیت انجام شد.");
  const successStyle = useCustomState({ successColor: GREEN_PRIMRY });

  const openSuccessModal = () => {
    successModalOpen.handleChange(true);
  };

  const counterInfoIsLoading = useCustomState(true);
  const counterInfo = useCustomState({ category: "" });

  const billsIsLoading = useCustomState(true);
  const bills = useCustomState([]);

  const paymentDeadline = useCustomState(moment().add(14, "day"));

  const newBillBtnActive = useCustomState(true);

  const counterUtils = {
    serial: serial,
    counterInfo: counterInfo,
    isLoading: counterInfoIsLoading,
  };

  const billUtils = {
    page: 1,
    count: 10000,
    counterSerial: serial,
    isLoading: billsIsLoading,
    bills: bills,
    paymentDeadline: null,
    billSerial: null,
    billStartDate: null,
    userId: null,
    userPhoneNumber: null,
    projectId: null,
    billEndDate: null,
    billCreateDate: null,
    dispatch: dispatch,
  };

  const registerBillError = useCustomState({ error: false, text: "" });

  useMountAPI(fetchCounterInfo, counterUtils);
  useMountAPI(fetchBills, billUtils);

  useEffect(() => {
    if (updateBillsTable) {
      fetchBills(billUtils);
    }
  }, [updateBillsTable]);

  const newBill = () => {
    newBillBtnActive.handleChange(false);
    registerBillError.handleChange({ error: false, text: "" });
    const deadline = paymentDeadline.value.format("YYYY-MM-DD");
    const counterSerial = serial;

    // console.log(deadline);

    const data = {
      water_meter_serial: counterSerial,
      payment_dead_line: deadline,
      other_information: {},
    };

    Call("POST", "bills/admin/createBill", data)
      .then((response) => {
        // console.log("bill create response: ", response);
        newBillBtnActive.handleChange(true);
        if (response.data.code === 200) {
          dispatch(UpdateBillsTable({ updateBillsTable: true }));
          successMessage.handleChange("قبض جدید با موفقیت صادر شد.");
          successStyle.handleChange({ successColor: GREEN_PRIMRY });
          openSuccessModal();
        }
      })
      .catch((error) => {
        newBillBtnActive.handleChange(true);
        if (error.response) {
          const data = error.response.data;
          // console.log(data);
          if (data.code === 403) {
            successMessage.handleChange(data.farsi_message);
            successStyle.handleChange({ successColor: ERROR_COLOR });
            openSuccessModal();
          } else if (data.code === 409) {
            registerBillError.handleChange({
              error: true,
              text:
                data.farsi_message +
                ". لطفا ابتدا رکوردهای محاسبه را از طریق دکمه تعیین نحوه محاسبه قبض اضافه کنید.",
            });
          } else {
            registerBillError.handleChange({
              error: true,
              text: "صدور قبض انجام نشد. در انجام فرآیند خطایی رخ داده است",
            });
          }
        }
      });
  };

  const goToCalculateBill = () => {
    history.push("/admin/counter/" + serial + "/how-to-calculate-bill");
  };

  const renderCounterInfoTable = () => {
    if (counterInfoIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "320px" }}>
          <Loading />
        </div>
      );
    } else {
      const categoryStyle = {
        color: "#fff",
        backgroundColor: "green",
        fontSize: "12px",
        borderRadius: "4px",
        paddingRight: "6px",
        paddingLeft: "6px",
        marginRight: "8px",
      };
      const validStyle = { ...categoryStyle };
      const activeStyle = { ...categoryStyle };
      if (counterInfo.value.category.includes("آب")) {
        categoryStyle.backgroundColor = BLUE_COLOR;
      } else if (counterInfo.value.category.includes("برق")) {
        categoryStyle.backgroundColor = ERROR_COLOR;
      } else {
        categoryStyle.backgroundColor = ORANGE_COLOR;
      }

      if (counterInfo.value.validation) {
        validStyle.backgroundColor = GREEN_PRIMRY;
      } else {
        validStyle.backgroundColor = ERROR_COLOR;
      }
      if (counterInfo.value.activation) {
        activeStyle.backgroundColor = GREEN_PRIMRY;
      } else {
        activeStyle.backgroundColor = ERROR_COLOR;
      }

      const category = (
        <span style={categoryStyle}>
          {convertNumbers(counterInfo.value.category)}
        </span>
      );

      const validation = counterInfo.value.validation ? (
        <span style={validStyle}>{"تایید شده"}</span>
      ) : (
        <span style={validStyle}>{"تایید نشده"}</span>
      );
      const activation = counterInfo.value.activation ? (
        <span style={activeStyle}>{"فعال"}</span>
      ) : (
        <span style={activeStyle}>{"غیر فعال"}</span>
      );
      return (
        <TableContainer component={Paper} style={{ marginBottom: "24px" }}>
          <Table sx={{ maxWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell align={"center"}>نام کنتور</TableCell>
                <TableCell align={"center"}>شماره سریال</TableCell>
                <TableCell align={"center"}>دسته</TableCell>
                <TableCell align={"center"}>نوع</TableCell>
                <TableCell align={"center"}>وضعیت تایید</TableCell>
                <TableCell align={"center"}>وضعیت فعالیت</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align={"center"}>
                  {convertNumbers(counterInfo.value.name)}
                </TableCell>
                <TableCell align={"center"}>
                  {convertNumbers(counterInfo.value.serial)}
                </TableCell>
                <TableCell align={"center"}>{category}</TableCell>
                <TableCell align={"center"}>{counterInfo.value.type}</TableCell>
                <TableCell align={"center"}>{validation}</TableCell>
                <TableCell align={"center"}>{activation}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  };

  const renderCounterInfo = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ marginBottom: "16px", marginTop: "48px" }}
        >
          <Typography style={{ fontWeight: "bold" }}>اطلاعات کنتور</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            borderBottom: "1px solid #333333",
          }}
        >
          {renderCounterInfoTable()}
        </Grid>
      </>
    );
  };

  const renderBillsTable = () => {
    if (billsIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "320px" }}>
          <Loading />
        </div>
      );
    } else {
      if (bills.value.length === 0) {
        return (
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "160px",
              border: "1px solid #333333",
              paddingTop: "8px",
              borderRadius: "12px",
            }}
          >
            <NotFound textSize={12} iconSize={64} />
          </div>
        );
      } else {
        return (
          <TableContainer component={Paper} style={{ marginBottom: "24px" }}>
            <Table sx={{ maxWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <TableCell align={"center"}>#</TableCell>
                  <TableCell align={"center"}>شناسه قبض</TableCell>
                  <TableCell align={"center"}>از تاریخ</TableCell>
                  <TableCell align={"center"}>تا تاریخ</TableCell>
                  <TableCell align={"center"}>میزان مصرف</TableCell>
                  <TableCell align={"center"}>قابل پرداخت(ریال)</TableCell>
                  <TableCell align={"center"}>جزئیات و دانلود</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {bills.value.map((bill, idx) => {
                  return (
                    <TableRow key={idx}>
                      <TableCell align={"center"}>
                        {convertNumbers(idx + 1)}
                      </TableCell>
                      <TableCell align={"center"}>
                        {convertNumbers(bill.serial)}
                      </TableCell>
                      <TableCell align={"center"}>
                        {convertNumbers(
                          moment(bill.from).locale("fa").format("YYYY/MM/DD")
                        )}
                      </TableCell>
                      <TableCell align={"center"}>
                        {convertNumbers(
                          moment(bill.to).locale("fa").format("YYYY/MM/DD")
                        )}
                      </TableCell>
                      <TableCell align={"center"}>
                        {convertNumbers(bill.consumptions)}
                      </TableCell>
                      <TableCell align={"center"}>
                        {convertNumbers(Split(bill.price))}
                      </TableCell>
                      <TableCell align={"center"}>
                        <Link
                          to={
                            "/admin/counter/" + serial + "/bills/" + bill.serial
                          }
                        >
                          <InfoIcon
                            style={{ color: BLUE_PRIMARY, cursor: "pointer" }}
                          />
                        </Link>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        );
      }
    }
  };

  const renderBills = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ marginBottom: "24px", marginTop: "16px" }}
        >
          <Typography style={{ fontWeight: "bold" }}>لیست قبض ها</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            borderBottom: "1px solid #333333",
            paddingBottom: "24px",
          }}
        >
          {renderBillsTable()}
        </Grid>
      </>
    );
  };

  const renderBtns = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            paddingBottom: "24px",
            marginTop: "16px",
          }}
        >
          <Button
            onClick={newBill}
            disabled={!newBillBtnActive.value}
            style={{
              backgroundColor: BLUE_PRIMARY,
              color: WHITE,
              opacity: newBillBtnActive.value ? "1" : "0.5",
            }}
          >
            صدور قبض جدید
          </Button>
          <Button
            onClick={goToCalculateBill}
            // disabled={!newBillBtnActive.value}
            style={{
              backgroundColor: DARK_SIDEBAR,
              color: WHITE,
              // opacity: newBillBtnActive.value ? "1" : "0.5",
              marginRight: "8px",
            }}
          >
            تعیین نحوه محاسبه قبض
          </Button>
          <Typography
            style={{
              color: "#333333",
              fontSize: "12px",
              marginRight: "8px",
              marginTop: "4px",
              display: newBillBtnActive.value ? "none" : "",
            }}
          >
            لطفا کمی صبر کنید...
          </Typography>
          <Typography
            style={{
              color: ERROR_COLOR,
              fontSize: "12px",
              marginRight: "8px",
              marginTop: "4px",
              display: registerBillError.value.error ? "" : "none",
            }}
          >
            {registerBillError.value.text}
          </Typography>
        </Grid>
      </>
    );
  };

  return (
    <>
      <SuccessModal
        open={successModalOpen}
        title={successTitle.value}
        message={successMessage.value}
        style={successStyle.value}
      />
      <Grid
        container
        style={{
          marginTop: "64px",
          paddingTop: "16px",
          paddingBottom: "16px",
          paddingRight: "8px",
          paddingLeft: "8px",
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            backgroundColor: WHITE,
            paddingRight: "16px",
            paddingLeft: "16px",
            paddingTop: "24px",
            paddingBottom: "24px",
            borderRadius: "8px",
            position: "relative",
          }}
        >
          <Box
            style={{
              maxWidth: "250px",
              marginRight: "auto",
              marginLeft: "auto",
              marginTop: "-60px",
              paddingRight: "36px",
              paddingLeft: "36px",
              paddingTop: "24px",
              paddingBottom: "24px",
              borderRadius: "12px",
              backgroundColor: GREEN_PRIMRY,
              color: WHITE,
              cursor: "pointer",
            }}
            textAlign={"center"}
          >
            <Typography style={{ fontWeight: "bold" }}>لیست قبض ها</Typography>
          </Box>
          <Grid container>
            {renderCounterInfo()}
            {renderBills()}
            {renderBtns()}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Bills;

const processCounterInfo = (info) => {
  const billRecords = info.other_information.billInfo
    ? info.other_information.billInfo
    : [];
  billRecords.map((r, idx) => {
    r.id = idx + 1;
    r.error = false;
    r.text = "";
  });
  const processedCounterInfo = {
    activation: info.water_meter_activation,
    orderable: info.water_meter_condition,
    name: info.water_meter_name,
    serial: info.water_meter_serial,
    category: info.water_meter_tag_info.water_meter_tag_name,
    type: info.water_meter_type_info.water_meter_type_name,
    validation: info.water_meter_validation,
    billRecords: billRecords,
    location: info.water_meter_location,
    information: info.other_information,
    moduleId: info.water_meter_module_info.water_meter_module_id,
    projectId: info.water_meter_project_info.project_id,
    userId: info.water_meter_user_info.user_id,
  };
  return processedCounterInfo;
};

const fetchCounterInfo = (utils) => {
  const serial = utils.serial;
  const isLoading = utils.isLoading;
  const counterInfo = utils.counterInfo;

  const data = {
    water_meter_serial: serial,
  };

  Call("POST", "watermeters/admin/getOne", data)
    .then((response) => {
      // console.log("fetch counter info: ", response);
      if (response.data.code == 200) {
        const processedCounterInfo = processCounterInfo(response.data.data);
        counterInfo.handleChange(processedCounterInfo);
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};

const processBills = (bills) => {
  if (bills.length === 0) {
    return bills;
  } else {
    const processedBills = [];
    bills.map((bill, idx) => {
      const data = {
        serial: bill.bill_serial,
        id: bill.bill_id,
        from: bill.bill_start_date,
        to: bill.bill_create_date,
        consumptions: bill.consumptions,
        price: bill.bill_price,
        createDate: bill.bill_create_date,
        userInfo: {
          name: bill.bill_user_info.user_name,
          lastname: bill.bill_user_info.user_lastname,
          id: bill.bill_user_info.user_id,
          phoneNumber: bill.bill_user_info.user_phone,
        },
      };
      processedBills.push(data);
    });
    return processedBills;
  }
};

const fetchBills = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const counterSerial = utils.counterSerial;
  const isLoading = utils.isLoading;
  const bills = utils.bills;
  const paymentDeadline = utils.paymentDeadline;
  const billSerial = utils.billSerial;
  const billStartDate = utils.billStartDate;
  const userId = utils.userId;
  const userPhoneNumber = utils.userPhoneNumber;
  const projectId = utils.projectId;
  const billEndDate = utils.billEndDate;
  const billCreateDate = utils.billCreateDate;
  const dispatch = utils.dispatch;

  const data = {
    page: page,
    count: count,
    water_meter_serial: counterSerial,
    bill_serial: billSerial,
    bill_start_date: billStartDate,
    user_id: userId,
    user_phone_number: userPhoneNumber,
    project_id: projectId,
    bill_end_date: billEndDate,
    payment_dead_line: paymentDeadline,
    bill_create_date: billCreateDate,
  };

  Call("POST", "bills/admin/getAll", data)
    .then((response) => {
      // console.log("bills info: ", response);
      if (response.data.code === 200) {
        dispatch(UpdateBillsTable({ updateBillsTable: false }));
        bills.handleChange(processBills(response.data.data));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};
